import { FaArrowLeft } from "react-icons/fa";

import { useLocation, useNavigate } from "react-router";
import { usePreviousPagePath } from "../../hook/usePreviousPagePath";
import CloseComponent from "./CloseComponent";
import useDeviceType from "../../hook/useDeviceType";
import { HiChevronLeft } from "react-icons/hi";
import { useTranslation } from "react-i18next";

const CloseDetailPage = ({ title, hasPrev, customClose, className }) => {
  //className是用來接roulette.js傳來的
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const navigate = useNavigate();
  const previousPage = usePreviousPagePath();

  const deviceType = useDeviceType();
  return (
    <section
      className={`h-[60px] mb-[7px] py-common-padding-y relative flex items-center justify-between relative ${className}`}
    >
      <div className="flex items-center text-light-text text-4xl">
        {hasPrev ? (
          hasPrev
        ) : deviceType === "Mobile" ? (
          <HiChevronLeft
            className="cursor-pointer"
            onClick={() => navigate("../")}
          />
        ) : (
          <div className="w-[20px]"></div>
        )}
      </div>
      <p className="mb-0 text-base-light-dark dark:text-base-light-white text-xl font-semibold text-center text-overflow w-[70%] absolute absolute-center">
        {title}
      </p>
      {/* absolute absolute-center !left-[calc(100%-20px)]  */}
      <div className="flex items-center text-light-text text-4xl">
        {customClose || <CloseComponent />}
      </div>
    </section>
  );
};

export default CloseDetailPage;
